export default "__VITE_ASSET__2447ac0a__"